import { Pipe, PipeTransform } from '@angular/core';

import { sanitizeAllowlistHtml } from '../utils/allowlist-html-sanitizer';

@Pipe({
  name: 'safeHtml',
  standalone: false,
})
export class SafeHtmlPipe implements PipeTransform {
  public transform(value: any): any {
    return sanitizeAllowlistHtml(value == null ? '' : String(value), {
      allowedTags: ['br'],
      preserveLineBreaks: true,
    });
  }
}
